import buildJson from "../../build.json";
import versionJson from "../../version.json";

const getBuildNumber = () => {
  let build = "local";

  try {
    build = buildJson.build;
  } catch (error) {
    console.error("Failed to get build number:", error);
  }

  return build;
};

export const environment = {
  production: true,
  VERSION: versionJson.appVersion,
  BUILD: getBuildNumber(),
};
